/**
 * SelectionSummary Component
 *
 * Shows selection count and primary action button for applying schema.
 */

import { Button } from "antd";
import { CheckCircle } from "lucide-react";

interface SelectionSummaryProps {
	selectedCount: number;
	totalCount: number;
	schemaType: "article" | "faq";
	onApply: () => void;
	disabled?: boolean;
}

export function SelectionSummary({
	selectedCount,
	totalCount,
	schemaType,
	onApply,
	disabled = false,
}: SelectionSummaryProps) {
	const schemaLabel = schemaType === "article" ? "Article" : "FAQ";
	const buttonText = `Apply ${schemaLabel} Schema to ${selectedCount} Selected`;

	return (
		<div className="flex items-center justify-between p-4 bg-muted rounded-lg border-t">
			<div className="flex items-center gap-2 text-sm text-muted-foreground">
				<CheckCircle size={16} className="text-green-500 dark:text-green-400" />
				<span>
					<span className="font-medium">{selectedCount}</span> of {totalCount}{" "}
					items selected
				</span>
			</div>

			<Button
				type="primary"
				onClick={onApply}
				disabled={disabled || selectedCount === 0}
				className="bg-green-600 hover:bg-green-700"
			>
				{selectedCount === 0 ? `Select items to apply ${schemaLabel} Schema` : buttonText}
			</Button>
		</div>
	);
}
